"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var immutable_1 = require("immutable");
var react_acdc_1 = __importStar(require("@seaweb/react-acdc"));
var Field_1 = require("@seaweb/coral/components/Field");
var Popper_1 = __importDefault(require("@seaweb/coral/components/Popper"));
var useControlProp_1 = __importDefault(require("@seaweb/coral/hooks/useControlProp"));
var SelectContext_1 = __importDefault(require("./SelectContext"));
var SelectSelectedOnMount_1 = __importDefault(require("./SelectSelectedOnMount"));
var defaultStateReducer = function (state, _a) {
    var nextState = _a.nextState;
    return nextState;
};
var Select = function (_a) {
    var idProp = _a.id, _b = _a.stateReducer, stateReducer = _b === void 0 ? defaultStateReducer : _b, valueProp = _a.value, _c = _a.initialValue, initialValue = _c === void 0 ? null : _c, onChange = _a.onChange, searchValueProp = _a.searchValue, _d = _a.initialSearchValue, initialSearchValue = _d === void 0 ? '' : _d, onSearch = _a.onSearch, initialIsOpen = _a.initialIsOpen, initialMouseHighlightedIndex = _a.initialMouseHighlightedIndex, onMouseHighlightedIndexChange = _a.onMouseHighlightedIndexChange, initialKeyboardHighlightedIndex = _a.initialKeyboardHighlightedIndex, initialSelectedIndex = _a.initialSelectedIndex, onSelect = _a.onSelect, children = _a.children, props = __rest(_a, ["id", "stateReducer", "value", "initialValue", "onChange", "searchValue", "initialSearchValue", "onSearch", "initialIsOpen", "initialMouseHighlightedIndex", "onMouseHighlightedIndexChange", "initialKeyboardHighlightedIndex", "initialSelectedIndex", "onSelect", "children"]);
    var _e = __read(useControlProp_1.default(valueProp, initialValue, onChange), 2), value = _e[0], setValue = _e[1];
    var _f = __read(useControlProp_1.default(searchValueProp, initialSearchValue, onSearch), 2), searchValue = _f[0], setSearchValue = _f[1];
    var _g = __read(react_1.useState(false), 2), justSelect = _g[0], setJustSelect = _g[1];
    var reducer = function (state, changes) {
        var nextState = changes.nextState;
        var action = changes.action;
        switch (action.type) {
            case react_acdc_1.ActionTypes.KeyDownEnter: {
                if (action.indices.indexOf(state.keyboardHighlightedIndex) === -1) {
                    nextState = __assign(__assign({}, nextState), { value: state.value });
                }
                else {
                    if (state.isOpen) {
                        setJustSelect(true);
                        if (onSelect)
                            onSelect(nextState.value);
                        if (value !== nextState.value) {
                            setValue(nextState.value);
                        }
                    }
                    nextState = __assign(__assign({}, nextState), { value: '' });
                }
                break;
            }
            case react_acdc_1.ActionTypes.OptionClick: {
                if (state.isOpen) {
                    setJustSelect(true);
                    if (onSelect)
                        onSelect(nextState.value);
                    if (value !== nextState.value) {
                        setValue(nextState.value);
                    }
                }
                nextState = __assign(__assign({}, nextState), { value: '' });
                break;
            }
            case react_acdc_1.ActionTypes.KeyDownEscape:
            case react_acdc_1.ActionTypes.InputBlur: {
                setJustSelect(false);
                nextState = __assign(__assign({}, nextState), { value: '' });
                break;
            }
            case react_acdc_1.ActionTypes.InputClick:
            case react_acdc_1.ActionTypes.InputChange:
            case react_acdc_1.ActionTypes.KeyDownArrowUp:
            case react_acdc_1.ActionTypes.KeyDownArrowDown: {
                setJustSelect(false);
                break;
            }
            case react_acdc_1.ActionTypes.OptionMouseEnter: {
                nextState = __assign(__assign({}, nextState), { keyboardHighlightedIndex: nextState.mouseHighlightedIndex });
                break;
            }
            default:
        }
        return stateReducer(state, { nextState: nextState, action: changes.action });
    };
    var id = Field_1.useId(idProp);
    var _h = __read(react_1.useState(immutable_1.Map()), 2), optionChilds = _h[0], setOptionChilds = _h[1];
    var setOptionChild = react_1.useCallback(function (optionValue, el) {
        setOptionChilds(function (curr) { return curr.set(optionValue, el); });
    }, []);
    var selectCtx = {
        optionChilds: optionChilds,
        setOptionChild: setOptionChild,
        value: value,
        setValue: setValue,
        justSelect: justSelect,
    };
    return (react_1.default.createElement(SelectContext_1.default.Provider, { value: selectCtx },
        react_1.default.createElement(Popper_1.default, null,
            react_1.default.createElement(react_acdc_1.default, __assign({ id: id, stateReducer: reducer, onChange: setSearchValue, value: searchValue, initialState: {
                    isOpen: initialIsOpen,
                    mouseHighlightedIndex: initialMouseHighlightedIndex,
                    keyboardHighlightedIndex: initialKeyboardHighlightedIndex,
                    selectedIndex: initialSelectedIndex,
                } }, props),
                children,
                react_1.default.createElement(SelectSelectedOnMount_1.default, null)))));
};
exports.default = react_1.memo(Select);
